import { findIconDefinition, IconDefinition, IconLookup, IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';

export function findIcon(prefix: IconPrefix, iconName: IconName) {
  const iconLookup: IconLookup = { prefix, iconName };
  return findIconDefinition(iconLookup);
}
